export const LIST_POST = 'LIST_POST'
export const LIST_POST_INFINITE = 'LIST_POST_INFINITE'
export const DETAIL_POST = 'DETAIL_POST'
export const POST_VIEW_SERIES = 'POST_VIEW_SERIES'
export const TOTAL_POST = 'TOTAL_POST'
